module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Edit outbound EDI Setup","notifyEdipartSaved":"Outbound EDI setup saved"},"no":{"title":"Rediger utgående EDI oppsett","notifyEdipartSaved":"Utgående EDI oppsett lagret"}}')
  delete Component.options._Ctor
}
